"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Badge } from "@/components/ui/badge";
function FeaturedPostContent() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="animate-pulse grid lg:grid-cols-12 gap-8 items-center">
        <div className="lg:col-span-7 h-[400px] md:h-[600px] bg-muted/50 rounded-xl"></div>
        <div className="lg:col-span-5 lg:-ml-16 z-10 h-[400px] bg-primary/10 rounded-xl"></div>
      </div>;
  }
  if (error || !posts || posts.length === 0) {
    return null;
  }
  return <>
      {posts.slice(0, 1).map((post, i) => <article data-index={i} key={post.id} className="grid lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-7 relative">
            <AspectRatio ratio={4 / 3} className="overflow-hidden rounded-xl shadow-2xl">
              {post.featuredImage ? <img src={post.featuredImage} alt={post.title} className="object-cover w-full h-full transition-transform duration-1000 hover:scale-105" loading="lazy" /> : <div className="w-full h-full bg-muted flex items-center justify-center">
                  <span className="text-muted-foreground font-serif italic">No image available</span>
                </div>}
            </AspectRatio>
          </div>
          
          <div className="lg:col-span-5 lg:-ml-16 z-10">
            <Card className="bg-white text-foreground p-8 md:p-12 lg:p-16 shadow-2xl border-none rounded-xl flex flex-col items-start">
              <Badge className="mb-8 bg-[var(--color-green-accent)] text-white hover:bg-[var(--color-green-accent)]/90 border-none rounded-sm uppercase tracking-[0.2em] text-xs px-4 py-1.5 font-medium">
                Featured Story
              </Badge>
              
              <h3 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold mb-6 leading-[1.1] text-foreground">
                {post.title}
              </h3>
              
              {post.excerpt && <div className="text-muted-foreground font-default text-lg md:text-xl mb-10 leading-relaxed line-clamp-3 [&>p]:mb-0" dangerouslySetInnerHTML={{
            __html: post.excerpt
          }} />}
              
              <Link to={post.link || "#"}>
                <Button className="bg-primary text-primary-foreground hover:bg-[var(--color-green-accent)] rounded-full px-8 py-6 text-sm uppercase tracking-[0.15em] font-semibold group transition-all duration-300">
                  Read Article
                  <ArrowRight className="ml-3 size-4 transition-transform duration-300 group-hover:translate-x-1.5" />
                </Button>
              </Link>
            </Card>
          </div>
        </article>)}
    </>;
}
export default function FeaturedPostSection() {
  const wp_query_params = {
    post_type: "post",
    per_page: 1,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="featured-post-section" className="bg-secondary py-20 md:py-32 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-1/3 bg-background/40 pointer-events-none" />
      
      <div className="container mx-auto px-4 relative z-10 max-w-7xl">
        <PostsProvider wp_query={{
        post_type: "post",
        per_page: 1,
        order: "desc",
        orderby: "date"
      }}>
          <FeaturedPostContent />
        </PostsProvider>
      </div>
    </section>;
}